import api from "../api";

export const getSeats = (params) =>
  api.get("/seat", { params });

export const addSeat = (payload) => api.post("/seat/add", payload);

export const updateSeat = (id, payload) =>
  api.post(`/seat/edit/${id}`, payload);

export const deleteSeat = (id) =>
  api.post(`/seat/delete/${id}`);

export const changeSeatStatus = (id, active) =>
  api.post(`/seat/change_status/${id}`, { active });

